import React from "react"
import styled from "styled-components"
import Text from "../Text"

const Box = styled.div`
    display: flex;
    alig-items: baseline;
`

const Square = styled.div`
    height: 20px;
    width: 20px;
    cursor: pointer;
    border-radius: 3px;
    bordaser: 1px solid;
    flex-direction: row;
    alig-items: center;
    justify-content: center;
    i {
        font-size: ${props => props.checked ? "1.5em;" : "0em;"}
    }
`


const CheckBox = props => {
    function onClick() {
        props.onClick(props.itemKey, !props.checked)
    }
    return <Box className={props.className} data-cy-test="#financial-input-check-repeat-cost" onClick={onClick}>
        <Square checked={props.checked} className="bg-info">
            <i className="fas fa-check text-dark"></i>
        </Square>
        <Text color="primary" className="ml-2">{props.label}</Text>
    </Box>
}

export default CheckBox


// WEBPACK FOOTER //
// ./src/_components/Checkbox/index.jsx